// The app's name, as artwork (2026-10-09: "lets use this as our splash title on the home page").
//
// ⚠ THE LETTERING IS BAKED INTO THE PICTURE and cannot be live text: the script is warped onto the
// tome's pages so it reads as printed in the book rather than floating over it. That is the whole
// point of the image, and it costs us live text, so:
//   • the picture carries alt="" and a real <h1> sits beside it, screen-reader-only. Otherwise the
//     name is either announced twice or not at all.
//   • two widths are shipped; a phone fetches the 1100 (104 KB) and never the 2172 (269 KB).
//   • the source PNG was 2.4 MB. Never ship that.
// The clean plate without lettering lives in the brand folder for anywhere that needs live text.
export function SplashTitle({ sub, sizes = "(max-width: 700px) 100vw, 72rem" }: {
  sub?: string;
  /**
   * ⚠ HOW WIDE THIS WILL ACTUALLY BE, which the browser cannot work out for itself before layout.
   * Get it wrong and it fetches the big file for a small slot: the sign-in page sits in a 34rem
   * column, and with the home page's 72rem hint it pulled 269 KB to fill 496 px. Each caller says
   * what its own column is.
   */
  sizes?: string;
}) {
  return (
    <div className="splash-title">
      <picture>
        <source
          type="image/webp"
          srcSet="/brand/splash-1100.webp 1100w, /brand/splash-2172.webp 2172w"
          sizes={sizes}
        />
        {/* width/height are the real pixels so the browser reserves the space and nothing jumps. */}
        <img src="/brand/splash-1100.webp" alt="" width={2172} height={724} decoding="async" />
      </picture>
      <h1 className="sr-only">Campaign Compendium</h1>
      {sub && <p className="muted splash-sub">{sub}</p>}
    </div>
  );
}
